module.exports = __webpack_public_path__ + "static/view-locations-005c3e72c7e44b214d03fc3b34324211.jpg";